import { createSlice } from "@reduxjs/toolkit";

// The store's public configuration from GET /storefront/config
const siteSlice = createSlice({
    name: "site",
    initialState: {
        config: null, // { name, announcement, about, heroBanners, contact, shipping, gst, ... }
        categories: [],
        loading: true,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setSite: (state, action) => {
            state.config = action.payload.store;
            state.categories = action.payload.categories;
            state.loading = false;
            state.error = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
    },
});

export const { setLoading, setSite, setError } = siteSlice.actions;
export const selectStoreConfig = (state) => state.site.config;
export const selectCategories = (state) => state.site.categories;

export default siteSlice.reducer;
